export const TITLE_TABLE_CORPORATE_LINKAGE_SCORE = [
  {
    title: '#',
    key: 'stt',
  },
  {
    title: 'score.premium.TABLE.COMPANY_NAME',
    key: 'organizationName',
  },
  {
    title: 'score.premium.TABLE.TAX_CODE',
    key: 'taxCode',
  },
  {
    title: 'score.premium.TABLE.RELATIONSHIP',
    key: 'relationship',
  },
  {
    title: 'score.premium.TABLE.PERFORMANCE',
    key: 'performanceScore',
  },
]
export const TYPE_SORT_BY = {
  ORG_NAME: 'organizationName',
  RELATIONSHIP: 'relationship',
  CREDIT: 'creditRiskScore',
  PERFORMANCE: 'performanceScore',
}
